export default {
  heading: 'Nunito Sans',
  body: 'Nunito Sans',
};
